<template>
	<div>
	<div class="hello">
			<header class="header ui-header-positive ui-border-b" style="padding:0 210px">
				<ul class="ui-tiled">
					<div><img src="/static/img/logo.png" /> </div>
					<router-link to="/devicemanage" tag="li" class="active">
						<div>设备控制</div>
					</router-link>
					<router-link to="/addDevice" tag="li">
						<div>添加设备</div>
					</router-link>
					<router-link to="/userManage" tag="li">
						<div>用户管理</div>
					</router-link>
					<router-link to="/msgLog" tag="li">
						<div>消息记录</div>
					</router-link>
					<router-link to="/send" tag="li">
						<div>指令群发</div>
					</router-link>
					<router-link to="/baidu" tag="li">
						<div>地图位置</div>
					</router-link>
					<router-link to="/info" tag="li">
						<div>个人信息</div>
					</router-link>

					<li v-on:click="logOut()">
						<div>退出</div>
					</li>
				</ul>
			</header>
		 </div>
        
 <div id="app">
 	 <button type="button" id="btnExport" class="je-btn je-bg-red je-rdu">导出Excel</button>
 	 
     <table class="table" id="tableExcel">
      <thead>
        <tr >
          <th>设备名称</th>
          <th>报警内容</th>
          <th>报警时间</th>
        </tr>
      </thead>
      <tbody>
          <tr v-for="v in list" >
          <td>{{v.eqName}}</td>
          <td>{{v.msgContext}}</td>
          <td>{{v.msgSendTime.substring(0,4)+"年"+v.msgSendTime.substring(4,6)+"月"+v.msgSendTime.substring(6,8)+"日"+v.msgSendTime.substring(8,10)+"时"+v.msgSendTime.substring(10,12)+"分"+v.msgSendTime.substring(12,14)+"秒"}}</td>
      </tbody>   
     </table>  
 </div>
 </div>
</template>
<script>
	export default{
    data(){
        return{
            list:[]
            
        }
    },
    
 

	mounted : function(){
		 
		
		
		 $("#btnExport").click(function () {
                $("#tableExcel").table2excel({
                    exclude  : ".noExl", 
                    filename : "data" + new Date().getTime() + ".xls", //文件名称
                    name: "Excel Document Name.xls",
                    exclude_img: true,
                    exclude_links: true,
                    exclude_inputs: true
 
                });
            });
		
		
		
   const history = window.sessionStorage;
         var uid = history.getItem("user");
       
        this.$http.post('/ZYun/HttpService.do', {
           "serviceCode":"1024",
           "uId":uid,
           pageSize: 1,
           pageNum:"22"
        })
        .then((response) => {
          if(response.data.respCode=="0000"){
//        	this.pageSize = pageSize;
//        	this.pageSize=parseInt(this.pageSize);
            this.list = response.data.msgLogList;

             
          }else{
            console.log(response);
          }
        })
        .catch((response) =>{
          console.log(response);
        })
		
		}
	}
	
	

</script>


// WEBPACK FOOTER //
// src/components/devicemanage/baojing.vue